import React from 'react';
export function TopBar() {
  return <div className="bg-fil-beige text-fil-cocoa py-2 px-4 text-center text-[11px] sm:text-sm font-semibold tracking-wide uppercase" data-id="element-210" data-mp="3sdwyhb040hms">
      <p data-id="element-211" data-mp="2359leh3rlzf3">Curso 100% digital · Acceso inmediato</p>
    </div>;
}